module.exports = __webpack_public_path__ + "static/img/logo_1.89e875a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_1.png
// module id = z7ll
// module chunks = 4